import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Grid, Link, Typography } from '@mui/material';
import { emptyArray } from 'constants/emptyConst';
import SubdirectoryArrowRightIcon from '@mui/icons-material/SubdirectoryArrowRight';
import { FinanacedOffersInfoValue } from '../../FolderGeneralDataStyles';

const FinancedOffersPartnerItemLevelComponent = ({ collection, hasNextLevel, openMasterPartner, masterPartnerApp, identation }) => {
  const [t] = useTranslation();
  const identationAdd = useRef(1.49);

  return (
    <>
      {collection.map(lvl => {
        return (
          <React.Fragment key={lvl.masterPartnerId}>
            <Grid container justifyContent='space-between' alignItems='center'>
              <Grid item xs={6} display='flex'>
                <SubdirectoryArrowRightIcon fontSize='small' />
                {masterPartnerApp ? (
                  <Link onClick={openMasterPartner(lvl.masterPartnerId)}>{`${lvl.partnerName || ' '}`}</Link>
                ) : (
                  <Typography>{`${lvl.partnerName || ' '}`}</Typography>
                )}
              </Grid>
              <Grid item xs={6}>
                <span>{`${
                  lvl.partnerRole
                    ? lvl.isRealBeneficiary
                      ? `${lvl.partnerRole} - ${t('Folder.GeneralData.FinancedOffers.Partner.RealBeneficiary')} `
                      : lvl.partnerRole
                    : ' '
                } ${lvl.shareholderLevel ? ' / ' + lvl.shareholderLevel + ' / ' : ''} `}</span>
                <FinanacedOffersInfoValue>
                  {lvl.shareholderLevel ? `${t('PERCENT_NUMBER', { number: lvl.percent || 0 })} %` : ''}
                </FinanacedOffersInfoValue>
              </Grid>
            </Grid>
            {hasNextLevel && (
              <FinancedOffersPartnerItemLevelComponent
                identation={identation + identationAdd.current}
                collection={lvl?.shareholders}
                openMasterPartner={openMasterPartner}
                masterPartnerApp={masterPartnerApp}
              />
            )}
          </React.Fragment>
        );
      })}
    </>
  );
};

FinancedOffersPartnerItemLevelComponent.defaultProps = {
  collection: emptyArray,
  hasNextLevel: false,
  identation: 0
};

FinancedOffersPartnerItemLevelComponent.propTypes = {
  collection: PropTypes.array.isRequired,
  hasNextLevel: PropTypes.bool.isRequired,
  openMasterPartner: PropTypes.func.isRequired,
  identation: PropTypes.number.isRequired,
  masterPartnerApp: PropTypes.bool
};

export default FinancedOffersPartnerItemLevelComponent;
